import { frontendURL } from 'dashboard/helper/URLHelper';
import BroadcastsPage from './Index.vue';

const meta = {
  permissions: ['administrator'],
};

const broadcastsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/broadcasts'),
      name: 'broadcast_campaigns_index',
      component: BroadcastsPage,
      meta,
    },
  ],
};

export default broadcastsRoutes;
